/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the difference between ssDNA and dsDNA weight?`)
};

const es_dnamw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre el peso de ADNss y ADNds?`)
};

const de_dnamw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen ssDNA- und dsDNA-Gewicht?`)
};

const nl_dnamw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen het gewicht van ssDNA en dsDNA?`)
};

const fr_dnamw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre la masse de l'ADNsb et de l'ADNdb ?`)
};

const it_dnamw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra il peso di ssDNA e dsDNA?`)
};

const pt_br2_dnamw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual a diferença entre o peso de ssDNA e dsDNA?`)
};

const pt_dnamw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre a massa de ssADN e de dsADN?`)
};

const ja_dnamw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNAとdsDNAの重量の違いは何ですか？`)
};

const zh_dnamw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA 和 dsDNA 的分子量有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_faq_q2", locale)
	if (locale === "en") return en_dnamw_faq_q2(inputs)
	if (locale === "es") return es_dnamw_faq_q2(inputs)
	if (locale === "de") return de_dnamw_faq_q2(inputs)
	if (locale === "nl") return nl_dnamw_faq_q2(inputs)
	if (locale === "fr") return fr_dnamw_faq_q2(inputs)
	if (locale === "it") return it_dnamw_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_faq_q2(inputs)
	if (locale === "pt") return pt_dnamw_faq_q2(inputs)
	if (locale === "ja") return ja_dnamw_faq_q2(inputs)
	return zh_dnamw_faq_q2(inputs)
};